(function documentContainerDetailControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerDetailController', [
            '$scope', '$state', '$translate', '$filter', '$stateParams', 'errorsExtend', 'documentContainerService', 'authExtend', 'documentService', 'alerts', 'documentAction', 'storageService', 'documentContainerAction', 'containerTypeService', 'favoritesService',
            function organizationalUnitDetailController($scope, $state, $translate, $filter, $stateParams, errors, documentContainerService, authExtend, documentService, alerts, documentAction, storageService, documentContainerAction, containerTypeService, favoritesService) {

                $scope.metadataNotEmpty = false;
                $scope.allRowDetailsOpened = false;
                $scope.favorited = false;
                $scope.showFavorite = false;

                $scope.loadActions = function () {
                    if (!$scope.container.containerTypeId) {
                        return;
                    }

                    containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], $scope.container.containerTypeId).then(function (r) { $scope.modifyOptions = r; });
                    containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], $scope.container.containerTypeId).then(function (r) { $scope.downloadBtn = r; });
                    containerTypeService.isContainertypeInRole(['FILE READ'], $scope.container.containerTypeId).then(function (r) { $scope.viewPDFBtn = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTVERSION READ'], $scope.container.containerTypeId).then(function (r) { $scope.versionView = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTVERSIONED WRITE'], $scope.container.containerTypeId).then(function (r) { $scope.checkInVersioned = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENT WRITE'], $scope.container.containerTypeId).then(function (r) { $scope.accesCheckIn = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER DELETE'], $scope.container.containerTypeId).then(function (r) { $scope.deleteOptions = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENT DELETE'], $scope.container.containerTypeId).then(function (r) { $scope.deleteDocumentsOptions = r; });
                    containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER CHECKINOUTALL'], $scope.container.containerTypeId).then(function (r) { $scope.canCheckInOutAll = r; });
                };

                $scope.documentsErrors = false;

                $scope.UserId = authExtend.getUserId();

                $scope.cancel = function () {
                    if ($scope.urlFind) {
                        $state.go($scope.urlFind);
                    } else {
                        $state.goBack('inicio');
                    }
                };

                $scope.load = function (documents_with_errors) {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0,
                        showNoData: false
                    };

                    $scope.mydata = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0,
                        showNoData: false
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLast', 'PaginationFirst'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLast,
                                firstText: translated.PaginationFirst
                            };
                        });

                    $scope.urlFind = storageService.getStateBackFind();
                    $scope.container = null;
                    $scope.userId = authExtend.getUserId();
                    $scope.documentId = $stateParams.docId;

                    $scope.options = {
                        toggleWrap: function (scope) {
                            var collapsed = scope.$nodeScope.collapsed = !scope.$nodeScope.collapsed;
                            if (!collapsed & !scope.hasChild()) {

                                documentContainerService.getTreeOf(scope.$nodeScope.$modelValue.id).then(function (result) {
                                    if (result.length > 0) {
                                        scope.$nodeScope.$modelValue.childs = result[0].childs;
                                    }
                                });
                            }
                        }
                    };

                    documentContainerService.getById($stateParams.id).then(function (result) {
                        if (result) {
                            $scope.container = result;
                            $scope.container.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });

                            $scope.showFavorite = $scope.container.checkedOutById === null || $scope.container.checkedOutById.toString() !== $scope.userId;

                            $scope.loadActions();

                            $scope.container.documents = [];

                            documentContainerService.getDocumentsFromContainer($stateParams.id, $scope.data.currentPage, $scope.data.itemsPerPage)
                                .then(function (resultDocs) {

                                    if (documents_with_errors !== undefined) {
                                        documents_with_errors.forEach(function (document) {
                                            var d = $filter('filter')(resultDocs.value, { id: document.id })[0];
                                            d.error = document.error;
                                            d.hasError = document.hasError;
                                        });

                                    }

                                    $scope.container.documents = resultDocs.value;

                                    if ($filter('filter')($scope.container.documents, { hasFile: true }).length < 1) {
                                        $scope.viewPDFBtn = false;
                                    }

                                    $scope.data.totalItems = resultDocs.totalCount;
                                    $scope.data.from = resultDocs.from;

                                    if ($scope.container.documents.length === 0) {
                                        $scope.data.showNoData = true;
                                    }
                                }, function (error) {
                                    errors.showError(error);
                                    $scope.cancel();
                                });

                            favoritesService.exists($stateParams.id, 'CONTAINERS').then(function (isInFavorites) {
                                $scope.favorited = isInFavorites;
                            }, function (error) {
                                defered.reject(error);
                            });

                            $scope.findMyDocuments();

                            var childTree = [{ childs: [], name: result.name, id: result.id }];
                            result.childs.forEach(function (child) {
                                childTree[0].childs.push({ name: child.childName, id: child.childId });
                            });

                            $scope.childTree = childTree;

                            var parentTree = [{ childs: [], name: result.name, id: result.id }];
                            result.documentContainersParent.forEach(function (parent) {
                                parentTree[0].childs.push({ name: parent.parentName, id: parent.parentId });
                            });

                            $scope.parentTree = parentTree;

                            $scope.metadataNotEmpty = ($scope.container.metadatas.length > 0);

                        } else {
                            $scope.tree = {};
                            errors.show('NotFound');
                            $scope.cancel();
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.goToContainer = function (container) {
                    $state.go('document-container-detail', { id: container.id });
                }

                $scope.rowDoc = function (document, mydoc) {
                    if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                        if (event.target.offsetParent !== null) {
                            $scope.view(document, mydoc);
                        }
                    }
                }

                $scope.view = function (document, mydoc) {
                    if (mydoc) {
                        $state.go('mydocument-detail-container', { id: document.id, containerId: $scope.container.id });
                    } else {
                        $state.go('document-detail-container', { id: document.id, containerId: $scope.container.id });
                    }
                };

                $scope.viewVersion = function (document) {
                    $state.go('document-version-all', { id: document.id });
                };

                $scope.modifyDoc = function (document) {
                    $state.go('document-modify', { id: document.id });
                };

                $scope.downloadFilesDocument = function (document) {
                    return documentAction.downloadFiles(document);
                }

                $scope.downloadAllDocuments = function () {
                    if ($scope.container.documents.length <= 0) {
                        errors.showError('VerifyNoDocumentsOnContainer');
                        return;
                    }
                    return documentContainerAction.downloadFiles($scope.container);
                }

                $scope.downloadContainer = function () {
                    if ($scope.container.documents.length <= 0) {
                        errors.showError('VerifyNoDocumentsOnContainer');
                        return;
                    }
                    return documentContainerAction.downloadFilesContainer($scope.container);
                }

                $scope.checkInDocument = function (document, index) {
                    return documentAction.checkIn(document)
                        .then(function (doc) {
                            $scope.findDocuemnts();

                            if ($scope.container.mydocuments.length === $scope.mydata.itemsPerPage) {
                                $scope.findMyDocuments();
                            } else {
                                $scope.container.mydocuments.splice(index, 1);
                                $scope.mydata.totalItems--;
                            }
                        });
                };

                $scope.checkOutDocument = function (document, index) {
                    return documentAction.checkOut(document)
                        .then(function (doc) {
                            $scope.container.documents[index].checkedOutById = doc.checkedOutById;
                            $scope.container.documents[index].checkedOutByNickName = doc.checkedOutByNickName;
                            $scope.findMyDocuments();
                        });
                };

                $scope.modify = function () {
                    $state.go('document-container-modify', { id: $stateParams.id });
                }

                $scope.checkIn = function () {
                    documentContainerAction.checkIn($scope.container)
                        .then(function getOk(result) {
                            $scope.container.checkedOutById = result.checkedOutById;
                            $scope.container.checkedOutByNickName = result.checkedOutByNickName;
                        }, function () {
                            $scope.load();
                        });
                };

                $scope.checkInAll = function () {
                    documentContainerAction.checkInAll($scope.container)
                        .then(function getOk() {
                            $scope.load();
                        }, function (error) {

                            $scope.documentsErrors = true;
                            var doc_with_errors = [];
                            var error_message = "";
                            var topErrors = 5;

                            for (var i = 0; i < error.data.modelState.error.length; i++) {
                                var id = error.data.modelState.error[i];
                                var doc = $filter('filter')($scope.container.documents, { id: id })[0];
                                doc.hasError = true;
                                doc.error = error.data.modelState.error[i + 1];

                                if (topErrors > 0) {
                                    error_message = error_message + doc.name + ": " + $filter('translate')(error.data.modelState.error[i + 1]) + "\n";
                                    topErrors--;
                                }

                                doc_with_errors.push(doc);

                                i++;
                            }

                            errors.showError(error_message);
                            $scope.load(doc_with_errors);
                        });
                };

                $scope.checkout = function () {
                    return $translate(['Warning', 'DocumentContainerCheckOutConfirmText', 'Yes', 'No'])
                        .then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DocumentContainerCheckOutConfirmText, translated.Yes, translated.No)
                                .then(function getOk(result) {
                                    if (!result) {
                                        return result;
                                    }

                                    return documentContainerService.checkout($scope.container)
                                        .then(function getOk(result) {
                                            $scope.container.checkedOutById = result.checkedOutById;
                                            $scope.container.checkedOutByNickName = result.checkedOutByNickName;
                                            errors.showSuccess('DocumentContainerCheckOutSucces');
                                        }, function (error) {
                                            errors.showError(error);
                                            $scope.load();
                                        });
                                });
                        });
                };

                $scope.checkOutAll = function () {
                    return $translate(['Warning', 'DocumentContainerCheckOutAllConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentContainerCheckOutAllConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return result;
                            }

                            return documentContainerService.checkOutAll($scope.container).then(function getOk() {
                                errors.showSuccess('DocumentContainerCheckOutSucces');
                                $scope.load();
                            }, function (error) {
                                errors.showError(error);
                                $scope.load();
                            });

                        });
                    });
                };

                function findById(document) {
                    if (!$scope.documentId) {
                        return false;
                    }

                    if (document.id === $scope.documentId || document.id.toString() === $scope.documentId ) {
                        return true;
                    } else {
                        return false;
                    }
                }

                $scope.backToDocument = function () {
                    var results = $scope.container.documents.filter(findById);
                    if (results.length > 0) {
                        $scope.view(results[0], false);
                    }

                    var resultsmy = $scope.container.mydocuments.filter(findById);
                    if (resultsmy.length > 0) {
                        $scope.view(resultsmy[0], true);
                    }                    
                };

                $scope.deleteContainer = function () {
                    return documentContainerAction.deleteContainer($scope.container).then(function (doc) {
                        if ($scope.urlFind) {
                            $state.go($scope.urlFind);
                        } else {
                            $state.go('inicio');
                        }
                    });
                };

                $scope.deleteDocument = function (document, index) {
                    return documentAction.deleteDocument(document).then(function () {
                        if ($scope.container.mydocuments.length === $scope.mydata.itemsPerPage) {
                            $scope.findMyDocuments();
                        } else {
                            $scope.container.mydocuments.splice(index, 1);
                            $scope.mydata.totalItems--;
                        }
                    });
                };

                $scope.findDocuemnts = function () {
                    $scope.container.documents = [];
                    $scope.data.showNoData = false;

                    return documentContainerService.getDocumentsFromContainer($stateParams.id, $scope.data.currentPage, $scope.data.itemsPerPage).then(function (resultDocs) {
                        $scope.container.documents = resultDocs.value;

                        $scope.data.totalItems = resultDocs.totalCount;
                        $scope.data.from = resultDocs.from;

                        if ($scope.container.documents.length === 0) {
                            $scope.data.showNoData = true;
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.container.documents = [];
                    });

                };

                $scope.findMyDocuments = function () {

                    $scope.container.mydocuments = [];
                    $scope.mydata.showNoData = false;

                    return documentContainerService.getMyDocumentsFromContainer($stateParams.id, $scope.mydata.currentPage, $scope.mydata.itemsPerPage).then(function (resultDocs) {
                        $scope.container.mydocuments = resultDocs.value;

                        $scope.mydata.totalItems = resultDocs.totalCount;
                        $scope.mydata.from = resultDocs.from;

                        if ($scope.container.mydocuments.length === 0) {
                            $scope.mydata.showNoData = true;
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.mydocuments.documents = [];
                    });
                };

                $scope.fillDocMetadata = function (document) {
                    if (document.documentTypes === undefined) {
                        var tempDocument = false;
                        if (document.checkedOutById === $scope.userId)
                            tempDocument = true;

                        return documentService.getById(document.id, tempDocument).then(function (result) {
                            document.documentTypes = result.documentTypes;

                            var hasMetadata = false;

                            document.documentTypes.forEach(function (docType) {
                                if (docType.metadatas.length > 0)
                                    hasMetadata = true;

                                docType.metadatas.sort(function (a, b) {
                                    return a.position - b.position;
                                });
                            });

                            document.hasMetadata = hasMetadata;
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                    }
                }

                $scope.openAllRowDetails = function () {
                    $scope.allRowDetailsOpened = !$scope.allRowDetailsOpened;
                    $scope.container.documents.forEach(function (item) {
                        item.isRowDetailOpen = $scope.allRowDetailsOpened;
                        if (item.isRowDetailOpen) {
                            $scope.fillDocMetadata(item);
                        }
                    });
                }

                $scope.openAllMyRowDetails = function () {
                    $scope.allMyRowDetailsOpened = !$scope.allMyRowDetailsOpened;
                    $scope.container.mydocuments.forEach(function (item) {
                        item.isRowDetailOpen = $scope.allMyRowDetailsOpened;
                        if (item.isRowDetailOpen) {
                            $scope.fillDocMetadata(item);
                        }
                    });
                }

                $scope.toggleAccordion = function (item) {
                    if (window.event) {
                        window.event.stopPropagation();
                    }
                    item.isRowDetailOpen = !item.isRowDetailOpen;
                    if (item.isRowDetailOpen) {
                        $scope.fillDocMetadata(item);
                    }
                };

                $scope.viewPDF = function () {
                    $state.go('file-document-container-detail', { id: $scope.container.id });
                };

                $scope.documentViewPDF = function (document) {
                    $state.go('file-document-detail', { id: document.id });
                };

                $scope.addFavorite = function () {
                    return favoritesService.addFavorite($stateParams.id, 'CONTAINERS').then(function getOk() {
                        $scope.favorited = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.removeFavorite = function () {
                    return favoritesService.removeFavorite($stateParams.id, 'CONTAINERS').then(function getOk() {
                        $scope.favorited = false;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load();
            }
        ]);
})();
